import { LeftTitle } from './sign-up.aside-style';

export const SignUpAside = () => <LeftTitle>Sign up for free no credit card needed</LeftTitle>;
